import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { HIDE_BETA_FEATURES } from "../../core/utils/hide-beta-features.token";

/**
 * Hides a route in builds where beta features are off.
 *
 * Use it with `canMatch` (not `canActivate`): when the flag is on the route is
 * treated as if it did not exist, so its lazy chunk is never downloaded and the
 * URL falls through to the `**` route, which lands on the not found page.
 */
export const betaFeatureGuard: CanMatchFn = () => !inject(HIDE_BETA_FEATURES);
